const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  // id: state => state.user.id,
  // avatar: state => state.user.avatar,
  // logoUrl: state => state.user.logoUrl,
  // name: state => state.user.name,
  userInfo: state => state.user.userInfo,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  functionKey: state => state.permission.functionKey,
  crmButtonAuth: state => state.permission.crmButtonAuth,
  menu_list: state => state.permission.menuList

}
export default getters
